import { TableCompHead } from '../../../../../components/ui';
import { useQuery } from '../../../../../hooks/UseQuery';

interface IProps {
  moduleData: any;
  isView: boolean;
  machineData: any;
}

const THead = ({ moduleData, isView, machineData }: IProps) => {
  const machineLength = machineData.length;
  const subDepartmentName = useQuery('subDepartmentName');
  return (
    <thead>
      <TableCompHead
        colSpan={5 + machineLength}
        rowSpan={3}
        labels={['Doc No', 'Rev', 'Dated']}
        values={['F-HRD-08A', '00', '01.04.2019']}
        heading="MAN MACHINE MATRIX"
      />
      <tr>
        <th colSpan={5 + machineLength} align="left">
          SUB-DEPTT NAME:{subDepartmentName}
        </th>
      </tr>
      <tr>
        <th colSpan={5 + machineLength} align="left">
          DEPTT OWNER NAME:
        </th>
      </tr>
      <tr
        style={{
          position: 'sticky',
          width: '100%',
          top: '3.6rem',
          border: '1px solid black',
          zIndex: '1',
          backgroundColor: 'rgb(79, 129, 189)',
          color: '#fff',
        }}
      >
        <th rowSpan={2}>S.N.</th>
        <th rowSpan={2}>OPERATOR NAME</th>
        <th rowSpan={2}>OPERATOR CODE</th>
        <th rowSpan={2}>SKILL LEVEL</th>
        {machineData.length > 0 && (
          <th colSpan={machineData.length}>MACHINE NO.</th>
        )}
        <th rowSpan={2}>REMARKS</th>
      </tr>
      <tr
        style={{
          position: 'sticky',
          width: '100%',
          top: '6.3rem',
          border: '1px solid black',
          zIndex: '1',
          backgroundColor: 'rgb(79, 129, 189)',
          color: '#fff',
        }}
      >
        {machineData.map((machine: any) => (
          <th>{machine.machine_no}</th>
        ))}
      </tr>
    </thead>
  );
};

export default THead;
